export default "__VITE_ASSET__bf833a6b__"